var fieldValidationMessageIds = {
    required: 'common_required',
    invalidEmail: 'Api_AuthController_error_invalid_email',
    invalidPassword: 'Api_AuthController_error_invalid_password',
    eightOrMoreCharacters: 'RegistrationViewNew_password_conditions1',
    upperAndLowerCaseLetters: 'RegistrationViewNew_password_conditions2',
    atLeastOneNumber: 'RegistrationViewNew_password_conditions3',
    passwordEntriesDoNotMatch: 'password_not_match_error',
    wrongResetCode: 'Api_AuthController_error_reset_password_token_incorrect',
};
export default fieldValidationMessageIds;
